const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins
class TimelineMainSection extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.setTallestSlideHeight()
    this.carousel = this.setupCarousel()

    this.setupDates()

    const initialIndex = this.carousel?.track?.details?.rel || 0
    this.setActiveSlideHeight(initialIndex)
    this.attachResizeObserverToSlide(initialIndex)
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('resize', () => {
      const currentIndex = this.carousel?.track?.details?.rel || 0
      this.setActiveSlideHeight(currentIndex)
    })
  }

  setTallestSlideHeight () {
    const tallestSlideHeight = this.getMaxHeight(this.els.itemBody.elements)
    this.els.slides.element.style.setProperty(
      '--carouselImageHeight',
      `${tallestSlideHeight}px`,
    )

    this.els.slides.element.style.height = `${tallestSlideHeight}px`
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        drag: true,
        vertical: true,
        rubberband: false,
        slides: {
          perView: 1,
          spacing: 30,
        },
        slideChanged: this.onSlideChanged,
      },
      [setInitialised(), addWheelControls('vertical')],
    )
  }

  setupDates () {
    this.els.dates.elements.forEach((slider) => {
      const thumbnailItems = slider.querySelectorAll(
        '.sec-FiftyFiftyTimeline_ItemsDatesItem',
      )
      thumbnailItems.forEach((item) => {
        item.addEventListener('click', () => {
          item.classList.remove('sec-FiftyFiftyTimeline_ItemsDatesItem-active')

          const itemIndexValue = item
            .querySelector('.sec-FiftyFiftyTimeline_ItemsDatesItemTrigger')
            .getAttribute('data-slide')

          this.carousel.moveToIdx(parseInt(itemIndexValue))

          thumbnailItems.forEach((thumb) => {
            thumb.classList.remove(
              'sec-FiftyFiftyTimeline_ItemsDatesItem-active',
            )
          })

          item.classList.add('sec-FiftyFiftyTimeline_ItemsDatesItem-active')
        })
      })
    })
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-current', index === currentSlide)
    })

    this.setActiveSlideHeight(currentSlide)
    this.attachResizeObserverToSlide(currentSlide)

    this.updateDates(currentSlide)
  }

  updateDates (currentSlide) {
    this.els.dates.elements.forEach((slider) => {
      const thumbnailItems = slider.querySelectorAll(
        '.sec-FiftyFiftyTimeline_ItemsDatesItem',
      )
      thumbnailItems.forEach((item) => {
        const itemIndexValue = parseInt(
          item
            .querySelector('.sec-FiftyFiftyTimeline_ItemsDatesItemTrigger')
            .getAttribute('data-slide'),
        )

        if (currentSlide === itemIndexValue) {
          item.classList.add('sec-FiftyFiftyTimeline_ItemsDatesItem-active')
        } else {
          item.classList.remove('sec-FiftyFiftyTimeline_ItemsDatesItem-active')
        }
      })
    })
  }

  setActiveSlideHeight (slideIndex) {
    const slideEl = this.els.slide.elements?.[slideIndex]
    if (!slideEl) return

    const itemBody = slideEl.querySelector(
      '[data-timeline-main-carousel-el="itemBody"]',
    )
    const height = itemBody ? itemBody.offsetHeight : slideEl.offsetHeight
    this.els.slides.element.style.setProperty(
      '--carouselImageHeight',
      `${height}px`,
    )

    this.els.slides.element.style.height = `${height}px`
  }

  attachResizeObserverToSlide (slideIndex) {
    const slideEl = this.els.slide.elements?.[slideIndex]
    if (!slideEl) return

    if (!this.itemBodyResizeObserver && 'ResizeObserver' in window) {
      this.itemBodyResizeObserver = new window.ResizeObserver(() => {
        const currentIndex = this.carousel?.track?.details?.rel || 0
        this.setActiveSlideHeight(currentIndex)
      })
    }

    if (this.itemBodyResizeObserver) {
      this.itemBodyResizeObserver.disconnect()
    }

    const itemBody = slideEl.querySelector(
      '[data-timeline-main-carousel-el="itemBody"]',
    )
    if (itemBody && this.itemBodyResizeObserver) {
      this.itemBodyResizeObserver.observe(itemBody)
    }

    const videos = slideEl.querySelectorAll('video')
    videos.forEach((video) => {
      const onMeta = () => {
        const currentIndex = this.carousel?.track?.details?.rel || 0
        this.setActiveSlideHeight(currentIndex)
        video.removeEventListener('loadedmetadata', onMeta)
        video.removeEventListener('loadeddata', onMeta)
      }
      video.addEventListener('loadedmetadata', onMeta, { once: true })
      video.addEventListener('loadeddata', onMeta, { once: true })
    })

    const images = slideEl.querySelectorAll('img')
    images.forEach((img) => {
      if (img.complete) return
      const onImgLoad = () => {
        const currentIndex = this.carousel?.track?.details?.rel || 0
        this.setActiveSlideHeight(currentIndex)
        img.removeEventListener('load', onImgLoad)
      }
      img.addEventListener('load', onImgLoad)
    })
  }

  getMaxHeight (elements) {
    return Math.max(...elements.map((element) => element.offsetHeight))
  }
}

class TimelineDates extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()
  }
}

if (!customElements.get('timeline-main-carousel')) {
  customElements.define('timeline-main-carousel', TimelineMainSection)
}

if (!customElements.get('timeline-dates')) {
  customElements.define('timeline-dates', TimelineDates)
}
